import { queryTestExecutions } from '@/features/executions/data/testExecutions';
import type { GridQueryInput } from '@/ui/composites/grid/gridUtils';
import type { QueryResult, TestExecutionDto } from '@flowqa/shared';

export const fetchTestExecutionsGrid = async (
  projectId?: string | null,
  organisationId?: string | null,
  input?: GridQueryInput,
): Promise<QueryResult<TestExecutionDto>> => {
  return await queryTestExecutions(projectId ?? undefined, organisationId ?? undefined, input);
};
